import React from 'react'
import { Dropzone, IDropzoneProps, IFileObject } from 'transfix-ui/components/Dropzone'
import { IconButton } from 'transfix-ui/components/IconButton'
import { Box, Card } from 'transfix-ui/core'
import { IFileCreate } from 'types'
import uuid from 'uuid'
import { DeleteIcon } from 'transfix-icons'

export interface IMultiFileDropzoneProps extends Omit<IDropzoneProps, 'onFileChange' | 'value'> {
  value: IFileCreate[]
  onFileChange: (newValue: IFileCreate[]) => void
}

export const mapDropzoneFiles = (files: IFileObject[] = []): IFileCreate[] => {
  return files.map(file => {
    const { data, file: fileInformation } = file || {}
    const { name: fileFileName, size } = fileInformation || {}
    return { file: data, fileFileName, size, uuid: uuid() }
  })
}

const MultiFileDropzone = ({
  dropZoneText = 'Upload',
  onFileChange,
  value = [],
  ...rest
}: IMultiFileDropzoneProps) => {
  const fileChangeHandler = (docs: IFileObject[]) => {
    if (docs) {
      const newFiles = mapDropzoneFiles(docs)
      if (newFiles) onFileChange([...value, ...newFiles])
    }
  }

  const removeFileHandler = (index: number) => {
    const files = [...value]
    files.splice(index, 1)
    onFileChange(files)
  }

  return (
    <div data-test='MultiFileDropzone'>
      {value &&
        value.map((file: IFileCreate, index: number) => (
          <Box mb={2} key={file.uuid}>
            <Card>
              <Box p={2} display='flex' alignItems='center' justifyContent='space-between'>
                {file.fileFileName}{' '}
                <IconButton
                  Icon={DeleteIcon}
                  label='Delete File'
                  size='large'
                  onClick={() => removeFileHandler(index)}
                />
              </Box>
            </Card>
          </Box>
        ))}
      <Dropzone dropZoneText={dropZoneText} onFileChange={fileChangeHandler} {...rest} />
    </div>
  )
}

export default MultiFileDropzone
